import { createApi } from '@stilingue/st-auth-utils';
import Service from './Service';
import { StFeatureFlagFlags } from '@/plugins/rollout';
import { isProdVersion } from '@stilingue/st-environment-controller-utils';
import Cookies from 'js-cookie';

const afterParser = (response) => {
  return response.data;
};

const isStaging = !isProdVersion();

const gatewayProd = StFeatureFlagFlags.gatewayProd.getValue();
const gatewayStaging = StFeatureFlagFlags.gatewayStaging.getValue();

const version = !isStaging
  ? 'prod'
  : 'staging';
const gateway = !isStaging
  ? gatewayProd
  : gatewayStaging;

class ImporterService extends Service {
  constructor(gateway, version) {
    const api = createApi(`/se-pdf-extractor/${version}/classify-pdf-v3?`, gateway);
    super(api, { afterParser });

    this.api.http.defaults.timeout = 300000;
  }

  importer(formdata, options) {
    const config = {
      params: options,
    };
    const headers = {
      'stilingue-session-id': Cookies.get('stilingue-session-id'),
    };
    return this.update(formdata, config, { headers });
  }
}

export default new ImporterService(gateway, version);
